module.exports = __webpack_public_path__ + "menu-088f316603ac6634697a.png";